import axiosInstance from '../api/axiosInstance';

const baseUrl = process.env.REACT_APP_API_URL;

export interface Merchant {
  id: number;
  company: string;
  address: string;
  contactPerson: string;
  createdAt: string;
  director: string;
  email: string;
  industry: string;
  locations: string;
  mobile: string;
  onlineShop: string;
  avgTxValue: string;
  taxId: string;
  telephone: string;
  currMonthVol: string;
  projMonthVolAcct: string;
  website: string;
}

export async function getAllMerchants(): Promise<Merchant[]> {
  const response = await axiosInstance.get(`${baseUrl}/admin/merchant`);
  return response.data;
}

export async function getMerchantById(id: number): Promise<Merchant> {
  const response = await axiosInstance.get(`${baseUrl}/admin/merchant/${id}`);
  return response.data;
}

export async function deleteMerchant(id: number): Promise<void> {
  await axiosInstance.delete(`${baseUrl}/admin/merchant/${id}`);
}
